import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type ConfigSlice = {
  isEU: boolean;
  /**
   * False while isEU is the anon shell's placeholder (DEV-5533) — i.e. geo has not
   * actually been resolved for this visitor yet. True once the value is server-resolved
   * (signed-in render) or bootstrap-hydrated. Lets consumers (e.g. web-vitals labeling)
   * distinguish "not EU" from "not known yet".
   */
  isEUResolved: boolean;
};

const initialState: ConfigSlice = {
  isEU: false,
  isEUResolved: false,
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    initConfig: (state, action: PayloadAction<{ isEU: boolean; isEUResolved: boolean }>) => {
      const { isEU, isEUResolved } = action.payload;
      state.isEU = isEU;
      state.isEUResolved = isEUResolved;
    },
  },
});

export const { initConfig } = configSlice.actions;
